var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.985 83.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reset",
    transform: "translate(-6.515 -8.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M86.39,67.4,96.5,49.89H89.83a41.656,41.656,0,1,0-12.2,29.791L72.77,74.82A34.79,34.79,0,1,1,82.95,49.89H76.29Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetBlack);
export default __webpack_public_path__ + "static/media/resetBlack.d2c2a8e7a090969bc928dfb83274cd93.svg";
export { ForwardRef as ReactComponent };